import VerticalPage from "@/components/VerticalPage";
import { MEDIA } from "@/lib/content";

export default function PrivateNetwork() {
  return (
    <VerticalPage
      overline="Private Network"
      title="Apply to Join the Private Network."
      subtitle="Moaglee is building a private network of property owners, investors, operators, sellers, and strategic partners — with access to deal flow that never hits the open market."
      image={MEDIA.network}
      statement="Access is by application. We curate for owners, investors, operators, and partners who control something real."
      bullets={[
        "Private, off-market deal flow",
        "Direct access to owners, investors & operators",
        "Members-only opportunities",
        "Strategic partner & referral network",
        "Priority on capital and CRE matches",
      ]}
      forms={["private_network"]}
      sourcePage="/private-network"
    />
  );
}
